import React from 'react';
import { IUseUserContextProps } from './useUserContext';

export const OrbUserContext = React.createContext<IUseUserContextProps>(null);